module.exports = __webpack_public_path__ + "static/img/invite-member-message.33f6d66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/invite-member-message.png
// module id = Y1Of
// module chunks = 6